module.exports = __webpack_public_path__ + "media/dangerous_goods_woodpacking_notification.48c00efa.mp3";